import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header, {
  EQUIP_SUB_INSPECTION,
  EQUIP_SUB_MANUFACTURING,
  isEquipmentMenu,
  isMyPageMenu,
  isOrgMenu,
  isProductMenu,
  isQualityMenu,
  isSafetyMenu,
  MENU_APPROVAL,
  MENU_BOARD,
  MENU_COMPANY,
  MENU_CONTRACT,
  MENU_EQUIPMENT,
  MENU_LEAVE,
  MENU_GATE_LOG,
  MENU_MY_PAGE,
  MENU_MY_PROFILE,
  MENU_OFFICIAL_DOCUMENT,
  MENU_ORG,
  MENU_PRODUCT,
  MENU_QUALITY,
  MENU_SAFETY,
  MENU_INTERNAL_DRAFT,
  MENU_MEETING_MINUTES,
  MENU_WORK_REPORT,
  ORG_SUB_JOIN_REQUEST,
  ORG_SUB_MEMBERS,
  ORG_SUB_AUDIT_LOG,
  PRODUCT_SUB_ACCEPTANCE,
  PRODUCT_SUB_CERTIFICATE,
  PRODUCT_SUB_FINAL,
  PRODUCT_SUB_INVENTORY,
  PRODUCT_SUB_LIST,
  PRODUCT_SUB_MENUS,
  PRODUCT_SUB_DAILY,
  PRODUCT_SUB_MID,
  PRODUCT_SUB_NCR,
  PRODUCT_SUB_ORDER,
  PRODUCT_SUB_PROCESS_CHART,
  PRODUCT_SUB_PRODUCT_MANUAL,
  PRODUCT_SUB_DRAWING,
  PRODUCT_SUB_VENDOR,
  QUALITY_SUB_AUDIT,
  QUALITY_SUB_CLEAN_ACTIVITY,
  QUALITY_SUB_COMPLAINT_AS,
  QUALITY_SUB_EDUCATION,
  QUALITY_SUB_EXTERNAL_AUDIT,
  QUALITY_SUB_POLICY,
  QUALITY_SUB_QC,
  QUALITY_SUB_SMALL_GROUP,
  QUALITY_SUB_SUGGESTION,
  SAFETY_SUB_CHECK,
  SAFETY_SUB_PPE,
} from '../components/layout/Header';
import Dashboard from '../components/layout/Dashboard';
import JoinRequestPanel from '../components/widgets/JoinRequestPanel';
import ApprovalPanel from '../components/approval/ApprovalPanel';
import BoardExplorer from '../components/board/BoardExplorer';
import ContractPanel from '../components/contract/ContractPanel';
import OrgAdminPanel from '../components/org/OrgAdminPanel';
import CompanySettingsPanel from '../components/company/CompanySettingsPanel';
import AuditLogPanel from '../components/company/AuditLogPanel';
import MyProfilePanel from '../components/mypage/MyProfilePanel';
import LeaveRequestPanel from '../components/mypage/LeaveRequestPanel';
import GateLogPanel from '../components/mypage/GateLogPanel';
import WorkReportPanel from '../components/mypage/WorkReportPanel';
import InternalDraftPanel from '../components/mypage/InternalDraftPanel';
import MeetingMinutesPanel from '../components/mypage/MeetingMinutesPanel';
import OfficialDocumentPanel from '../components/document/OfficialDocumentPanel';
import ProductPanel from '../components/product/ProductPanel';
import CertificatePanel from '../components/product/CertificatePanel';
import ProcessChartPanel from '../components/product/ProcessChartPanel';
import ProductManualPanel from '../components/product/ProductManualPanel';
import DrawingPanel from '../components/product/DrawingPanel';
import AcceptanceInspectionPanel from '../components/product/AcceptanceInspectionPanel';
import MidInspectionPanel from '../components/product/MidInspectionPanel';
import FinalInspectionPanel from '../components/product/FinalInspectionPanel';
import NonconformanceReportPanel from '../components/product/NonconformanceReportPanel';
import ProductionDailyReportPanel from '../components/product/ProductionDailyReportPanel';
import InventoryPanel from '../components/product/InventoryPanel';
import VendorPanel from '../components/product/VendorPanel';
import PurchaseOrderPanel from '../components/product/PurchaseOrderPanel';
import ProductPlaceholder from '../components/product/ProductPlaceholder';
import ManufacturingEquipPanel from '../components/equipment/ManufacturingEquipPanel';
import QualityPolicyPanel from '../components/quality/QualityPolicyPanel';
import QcAnalyticsPanel from '../components/quality/QcAnalyticsPanel';
import ComplaintAsPanel from '../components/quality/ComplaintAsPanel';
import EducationPanel from '../components/quality/EducationPanel';
import SmallGroupPanel from '../components/quality/SmallGroupPanel';
import CleanActivityPanel from '../components/quality/CleanActivityPanel';
import ImprovementSuggestionPanel from '../components/quality/ImprovementSuggestionPanel';
import InternalAuditPanel from '../components/quality/InternalAuditPanel';
import ExternalAuditPanel from '../components/quality/ExternalAuditPanel';
import SafetyPpeIssuancePanel from '../components/safety/SafetyPpeIssuancePanel';
import SafetyCheckSheetPanel from '../components/safety/SafetyCheckSheetPanel';
import BulletinPanel from '../components/bulletin/BulletinPanel';
import { NcrCreatePrefill } from '../types/nonconformanceReport';
import { useCompanyStore } from '../store/companyStore';
import { isGuest } from '../types/companyRole';
import { useGuestReadOnlyGuard } from '../hooks/useGuestReadOnlyGuard';
import { fetchCompanyPlanStatus } from '../api/companyPlan';
import '../App.css';
import '../components/layout/Dashboard.css';
import '../components/widgets/ListWidgets.css';

const PRODUCT_DESCRIPTIONS: Record<string, string> = {
  [PRODUCT_SUB_PROCESS_CHART]: '제조 공정 문서와 첨부파일을 관리합니다.',
  [PRODUCT_SUB_PRODUCT_MANUAL]: '제품군별 사용설명서를 첨부파일로 관리합니다.',
  [PRODUCT_SUB_DRAWING]: '제품 도면 파일과 개정 정보를 관리합니다.',
};

function DashboardPage() {
  const location = useLocation();
  const role = useCompanyStore((s) => s.role);
  const companyId = useCompanyStore((s) => s.companyId);
  const setPlan = useCompanyStore((s) => s.setPlan);
  const guestMode = isGuest(role);
  useGuestReadOnlyGuard(guestMode);
  const [activeKey, setActiveKey] = useState(MENU_MY_PAGE);
  const [activeBoardName, setActiveBoardName] = useState('');
  const [approvalTab, setApprovalTab] = useState<'all' | 'inbox' | 'sent'>('all');
  const [openContractId, setOpenContractId] = useState<number | null>(null);
  const [ncrPrefill, setNcrPrefill] = useState<NcrCreatePrefill | null>(null);
  const [ncrReportId, setNcrReportId] = useState<number | null>(null);

  useEffect(() => {
    if (!companyId) return;
    let cancelled = false;
    void fetchCompanyPlanStatus()
      .then((status) => {
        if (!cancelled) setPlan(status.plan);
      })
      .catch(() => {
        // 요금제 조회 실패는 메뉴만 기본값 유지
      });
    return () => {
      cancelled = true;
    };
  }, [companyId, setPlan]);

  useEffect(() => {
    const state = location.state as {
      activeMenu?: string;
      approvalTab?: 'all' | 'inbox' | 'sent';
      contractId?: number;
      ncrPrefill?: NcrCreatePrefill;
      ncrReportId?: number;
    } | null;
    if (state?.activeMenu) {
      setActiveKey(state.activeMenu);
      setActiveBoardName('');
    }
    if (state?.approvalTab) {
      setApprovalTab(state.approvalTab);
    }
    if (state?.contractId != null) {
      setOpenContractId(state.contractId);
    } else if (state?.activeMenu === MENU_CONTRACT) {
      setOpenContractId(null);
    }
    if (state?.ncrPrefill) {
      setNcrPrefill(state.ncrPrefill);
    }
    if (state?.ncrReportId != null) {
      setNcrReportId(state.ncrReportId);
    }
  }, [location.state]);

  const handleChangeActiveKey = (key: string, boardName?: string) => {
    setActiveKey(key);
    setActiveBoardName(boardName ?? '');
    if (key !== MENU_CONTRACT) setOpenContractId(null);
    if (key !== PRODUCT_SUB_NCR) {
      setNcrPrefill(null);
      setNcrReportId(null);
    }
  };

  const clearNcrPrefill = useCallback(() => setNcrPrefill(null), []);
  const clearNcrReportId = useCallback(() => setNcrReportId(null), []);

  const isBoardMenu =
    !isMyPageMenu(activeKey) &&
    activeKey !== MENU_CONTRACT &&
    activeKey !== MENU_OFFICIAL_DOCUMENT &&
    activeKey !== MENU_BOARD &&
    activeKey !== MENU_APPROVAL &&
    !isOrgMenu(activeKey) &&
    !isProductMenu(activeKey) &&
    !isEquipmentMenu(activeKey) &&
    !isQualityMenu(activeKey) &&
    !isSafetyMenu(activeKey) &&
    /^\d+$/.test(activeKey);

  const productTitle =
    (PRODUCT_SUB_MENUS as readonly string[]).includes(activeKey) ? activeKey : PRODUCT_SUB_LIST;

  return (
    <div className={`ec-app${guestMode ? ' is-guest-readonly' : ''}`}>
      <Header activeKey={activeKey} onChangeActiveKey={handleChangeActiveKey} />
      <div className="ec-app__body">
        {activeKey === ORG_SUB_JOIN_REQUEST ? (
          <main className="ec-dashboard">
            <div className="ec-dashboard__join">
              <JoinRequestPanel />
            </div>
          </main>
        ) : activeKey === MENU_APPROVAL ? (
          <main className="ec-dashboard">
            <div className="ec-dashboard__join">
              <ApprovalPanel initialTab={approvalTab} />
            </div>
          </main>
        ) : activeKey === MENU_COMPANY ? (
          <CompanySettingsPanel />
        ) : activeKey === MENU_MY_PROFILE ? (
          <MyProfilePanel />
        ) : activeKey === MENU_LEAVE ? (
          <LeaveRequestPanel />
        ) : activeKey === MENU_GATE_LOG ? (
          <GateLogPanel />
        ) : activeKey === MENU_WORK_REPORT ? (
          <WorkReportPanel />
        ) : activeKey === MENU_INTERNAL_DRAFT ? (
          <InternalDraftPanel />
        ) : activeKey === MENU_MEETING_MINUTES ? (
          <MeetingMinutesPanel />
        ) : activeKey === MENU_ORG || activeKey === ORG_SUB_MEMBERS ? (
          <OrgAdminPanel />
        ) : activeKey === ORG_SUB_AUDIT_LOG ? (
          <AuditLogPanel />
        ) : activeKey === MENU_CONTRACT ? (
          <ContractPanel initialContractId={openContractId} />
        ) : activeKey === MENU_OFFICIAL_DOCUMENT ? (
          <OfficialDocumentPanel />
        ) : activeKey === MENU_BOARD ? (
          <BulletinPanel />
        ) : activeKey === PRODUCT_SUB_LIST || activeKey === MENU_PRODUCT ? (
          <ProductPanel />
        ) : activeKey === PRODUCT_SUB_INVENTORY ? (
          <InventoryPanel />
        ) : activeKey === PRODUCT_SUB_VENDOR ? (
          <VendorPanel />
        ) : activeKey === PRODUCT_SUB_CERTIFICATE ? (
          <CertificatePanel />
        ) : activeKey === PRODUCT_SUB_PROCESS_CHART ? (
          <ProcessChartPanel />
        ) : activeKey === PRODUCT_SUB_PRODUCT_MANUAL ? (
          <ProductManualPanel />
        ) : activeKey === PRODUCT_SUB_DRAWING ? (
          <DrawingPanel />
        ) : activeKey === PRODUCT_SUB_ORDER ? (
          <PurchaseOrderPanel />
        ) : activeKey === PRODUCT_SUB_ACCEPTANCE ? (
          <AcceptanceInspectionPanel />
        ) : activeKey === PRODUCT_SUB_MID ? (
          <MidInspectionPanel />
        ) : activeKey === PRODUCT_SUB_FINAL ? (
          <FinalInspectionPanel />
        ) : activeKey === PRODUCT_SUB_DAILY ? (
          <ProductionDailyReportPanel />
        ) : activeKey === PRODUCT_SUB_NCR ? (
          <NonconformanceReportPanel
            prefill={ncrPrefill}
            onPrefillConsumed={clearNcrPrefill}
            initialReportId={ncrReportId}
            onInitialReportConsumed={clearNcrReportId}
          />
        ) : isProductMenu(activeKey) ? (
          <ProductPlaceholder
            title={productTitle}
            description={PRODUCT_DESCRIPTIONS[productTitle]}
          />
        ) : activeKey === MENU_EQUIPMENT || activeKey === EQUIP_SUB_MANUFACTURING ? (
          <ManufacturingEquipPanel equipmentType="MANUFACTURING" />
        ) : activeKey === EQUIP_SUB_INSPECTION ? (
          <ManufacturingEquipPanel equipmentType="INSPECTION" />
        ) : activeKey === QUALITY_SUB_POLICY || activeKey === MENU_QUALITY ? (
          <QualityPolicyPanel />
        ) : activeKey === QUALITY_SUB_QC ? (
          guestMode ? (
            <main className="quality-shell">
              <div className="quality-shell__toolbar">
                <div>
                  <h2>QC 분석</h2>
                  <p>게스트 계정은 QC 분석을 이용할 수 없습니다.</p>
                </div>
              </div>
            </main>
          ) : (
            <QcAnalyticsPanel />
          )
        ) : activeKey === QUALITY_SUB_COMPLAINT_AS ? (
          <ComplaintAsPanel />
        ) : activeKey === QUALITY_SUB_EDUCATION ? (
          <EducationPanel />
        ) : activeKey === QUALITY_SUB_SMALL_GROUP ? (
          <SmallGroupPanel />
        ) : activeKey === QUALITY_SUB_CLEAN_ACTIVITY ? (
          <CleanActivityPanel />
        ) : activeKey === QUALITY_SUB_SUGGESTION ? (
          <ImprovementSuggestionPanel />
        ) : activeKey === QUALITY_SUB_AUDIT ? (
          <InternalAuditPanel />
        ) : activeKey === QUALITY_SUB_EXTERNAL_AUDIT ? (
          <ExternalAuditPanel />
        ) : activeKey === SAFETY_SUB_PPE || activeKey === MENU_SAFETY ? (
          <SafetyPpeIssuancePanel />
        ) : activeKey === SAFETY_SUB_CHECK ? (
          <SafetyCheckSheetPanel />
        ) : isBoardMenu ? (
          <BoardExplorer
            boardId={Number(activeKey)}
            boardName={activeBoardName || '회사 공통 메뉴'}
          />
        ) : (
          <Dashboard />
        )}
      </div>
      <footer className="ec-app__footer">
        <span>Linelog</span>
        <span className="ec-app__footer-sep" aria-hidden="true">
          ·
        </span>
        <span>
          문의사항은{' '}
          <a href="mailto:ksg04001@daum.net">ksg04001@daum.net</a>
          으로 연락해 주세요.
        </span>
      </footer>
    </div>
  );
}

export default DashboardPage;
